import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, Link } from '@honda-canada/design-system-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import themeStyles from './SpecialOfferCard.styles';
const StyledExploreLink = themeStyles.apply(Link, 'StyledExploreLink');
const ExploreLink = ({ cta }) => {
    const { t } = useTranslation();
    const { link } = cta;
    return (_jsxs(StyledExploreLink, { href: link, styling: "primary", width: "fit-content", children: [t('Pages.SpecialOffers.exploreModelButton'), _jsx(Icon, { ml: 1, height: "10px", name: "arrowRight", iconColor: "primary" })] }));
};
export default ExploreLink;
